export default {
    'Banner列表':'Banner列表',
    '应用端':'应用端',
    '位置':'位置',
    '编辑banner':'编辑banner',
    '添加图片':'添加图片',
    '固定banner':'固定banner',
    '图片':'图片',
    '链接到':'链接到',
    '链接地址':'链接地址',
    '上传banner图':'上传banner图',
    '最多只可以同时存在五张轮播图哦！':'最多只可以同时存在五张轮播图哦！',
    '取消后，页面数据不再保存':'取消后，页面数据不再保存',
    '确认要删除该bannner图吗？':'确认要删除该bannner图吗？',

    //5.16
    '关闭后，将不在本机构显示此banner':'关闭后，将不在本机构显示此banner',
    '开启后，将在本机构显示此banner':'开启后，将在本机构显示此banner',
    '确认要删除吗':'确认要删除吗',
    '发布机构':'发布机构：',
    '开启关闭':'开启/关闭',
    '不能上移啦':'不能上移啦~',
    '不能下移啦':'不能下移啦~',

}